import { WorkerWrapper } from '../utilities/worker';
import {
  RenderQuotePdfWorkerInput,
  RenderQuotePdfWorkerOutput,
} from '../workers/renderQuotePdf.worker';

export const RenderQuotePdfWorker = WorkerWrapper?.bind<
  [() => Worker],
  [],
  WorkerWrapper<RenderQuotePdfWorkerInput, RenderQuotePdfWorkerOutput>
>(
  WorkerWrapper,
  () =>
    new Worker(new URL('../workers/renderQuotePdf.worker.ts', import.meta.url))
);
